var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignIconMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.8947 30.9474C61.8947 48.0372 48.0372 61.8947 30.9474 61.8947C13.8576 61.8947 0 48.0372 0 30.9474C0 13.8576 13.8576 0 30.9474 0C48.0372 0 61.8947 13.8576 61.8947 30.9474Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2313 16.9282C40.3289 16.9282 45.58 22.2194 45.58 30.6349C45.58 39.7325 40.0079 44.9836 30.5892 44.9836H21.5317V16.9282H31.2313ZM30.3485 41.7389C34.3957 41.7791 42.1691 40.6153 42.1691 30.6349C42.1691 23.4232 38.0015 20.1327 31.0651 20.1729L25.1318 20.213V41.6931L30.3427 41.7332L30.3485 41.7389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIconMedium);
export default __webpack_public_path__ + "static/media/designIconMedium.dc1573b2.svg";
export { ForwardRef as ReactComponent };var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignIconMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.8947 30.9474C61.8947 48.0372 48.0372 61.8947 30.9474 61.8947C13.8576 61.8947 0 48.0372 0 30.9474C0 13.8576 13.8576 0 30.9474 0C48.0372 0 61.8947 13.8576 61.8947 30.9474Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2313 16.9282C40.3289 16.9282 45.58 22.2194 45.58 30.6349C45.58 39.7325 40.0079 44.9836 30.5892 44.9836H21.5317V16.9282H31.2313ZM30.3485 41.7389C34.3957 41.7791 42.1691 40.6153 42.1691 30.6349C42.1691 23.4232 38.0015 20.1327 31.0651 20.1729L25.1318 20.213V41.6931L30.3427 41.7332L30.3485 41.7389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIconMedium);
export default __webpack_public_path__ + "static/media/designIconMedium.dc1573b2.svg";
export { ForwardRef as ReactComponent };